import React, { Component } from 'react';
import { connect } from 'react-redux';
import TobaList from "../../components/Tobas/tobaList";
import {deleteToba, getTobas} from "../../actions/tobas";
import {requestGetGroupsOfSolicitors} from "../../actions/groups";
import { push } from 'connected-react-router';
// import { push } from 'react-router-redux';
import {changeTobaListStoreSettings} from "../../actions/tobaList";
import _ from 'lodash';
import {getTobaRevisions, clearNewToba} from "../../actions/toba";
import { TOBA_PATH } from '../../helpers/variables';
class TobaListHOC extends Component {

  componentDidMount() {
    let calcOffset =this.props.tobaList.displayAmount*(this.props.tobaList.page -1);
    this.props.getTobas(
        {
          limit: this.props.tobaList.displayAmount,
          offset: calcOffset>0? calcOffset:0,
        }
    );
  }

  componentWillReceiveProps(nextProps){
    if(
        (this.props.tobaList.page !== nextProps.tobaList.page ||
            this.props.tobaList.displayAmount !== nextProps.tobaList.displayAmount) &&
        (!this.props.fetchingTobas)
    ){
      let totalDisplayBoxes = Math.ceil(nextProps.tobaList.totalRecords / parseInt(nextProps.tobaList.displayAmount));
      let currentPage = parseInt(nextProps.tobaList.page);
      if(currentPage > totalDisplayBoxes){
        currentPage = totalDisplayBoxes;
      }


      let calcOffset =nextProps.tobaList.displayAmount*(currentPage -1);
      this.props.getTobas(
          {
            limit: nextProps.tobaList.displayAmount,
            offset: calcOffset>0? calcOffset:0,
          }
      );
    }
    if(this.props.postingToba && !nextProps.postingToba){
      let totalDisplayBoxes = Math.ceil(nextProps.tobaList.totalRecords / parseInt(nextProps.tobaList.displayAmount));
      let currentPage = parseInt(nextProps.tobaList.page);
      if(currentPage > totalDisplayBoxes){
        currentPage = totalDisplayBoxes;
      }


      let calcOffset =nextProps.tobaList.displayAmount*(currentPage -1);
      this.props.getTobas(
          {
            limit: nextProps.tobaList.displayAmount,
            offset: calcOffset>0? calcOffset:0,
          }
      );
    }
  }

  _handleSelectChange = (evt) => {
    this.props.changeStoreSettings(evt.target.name, evt.target.value)
  };

  //action handler
  _handleApplyButton = () => {
    if(Object.keys(this.props.tobaList.selectedTobas).length === 0) {
      return 0;
    }
    if(this.props.tobaList.deleting){
      return 0;
    }
    if(this.props.tobaList.selectedAction === 'delete'){
      this.props.changeStoreSettings('deleteModalOpen', true)
    }
  };

  //closes the modal
  _closeModal = () => {
    this.props.changeStoreSettings('deleteModalOpen', false)
  };

  _deleteSelectedTobas = () => {
    _.forEach(this.props.tobaList.selectedTobas, toba => {
      this.props.deleteToba(toba.id)
    })
  };

  //closes the toba form modal
  _closeTobaFormModal = () => {
    this.props.changeStoreSettings('tobaFormModalOpen', false)
  };

  //opens the toba form modal
  _openTobaFormModal = () => {
    // clear stale toba form state (successMsg, errors, attachments) before showing a fresh create form;
    // without this, successMsg from the previous submission would appear on the newly opened blank form
    this.props.clearNewToba();
    this.props.changeStoreSettings('tobaFormModalOpen', true);
  };

  _onRowClick = (evt, tobaId, tobaName) => {
    if(evt.button === 1){
      window.open(`/solicitors/${TOBA_PATH}s` + tobaId, '_blank');
    } else {
      this.props.push( `/solicitors/${TOBA_PATH}s` + tobaId);
    }
  };

  //function that opens modal with the sol groups of the selected toba
  _viewTobaSolicitorGroupsInModal = (tobaId) => {
    this.props.changeStoreSettings('openTobaGroupDetailsModal', true);
    this.props.changeStoreSettings('selectedTobaToSeeGroups', tobaId);
  };

  //closes the toba solicitor groups modal
  _closeTobaSolicitorGroupsModal = () => {
    this.props.changeStoreSettings('openTobaGroupDetailsModal', false);
    this.props.changeStoreSettings('selectedTobaToSeeGroups', '');
  };

  onListItemSelect = (checked, rowIndex, row) => {
    let selectedItems = {};
    if (checked) {
      selectedItems = { ...this.props.tobaList.selectedTobas, [rowIndex]: row }

    } else {
      selectedItems = _.omit(this.props.tobaList.selectedTobas, [rowIndex]);
    }

    this.props.changeStoreSettings('selectedTobas', selectedItems);
  };

  onSelectAllItems = (checked) => {
    let selectedTobas = {};
    if (checked) {
      this.props.tobas.forEach((claim, index) => {
        selectedTobas = { ...selectedTobas, [index]: claim };
      });
    }

    this.props.changeStoreSettings('selectedTobas', selectedTobas);
  };

  render() {
    return(
        <TobaList
            onListItemSelect={this.onListItemSelect}
            onSelectAllItems={this.onSelectAllItems}
            _viewTobaSolicitorGroupsInModal={this._viewTobaSolicitorGroupsInModal}
            _closeTobaSolicitorGroupsModal={this._closeTobaSolicitorGroupsModal}
            fetchingTobas={this.props.fetchingTobas}
            _handleStoreChange={this.props.changeStoreSettings}
            _openTobaFormModal={this._openTobaFormModal}
            _closeTobaFormModal={this._closeTobaFormModal}
            _deleteSelectedTobas={this._deleteSelectedTobas}
            _closeModal={this._closeModal}
            _handleApplyButton={this._handleApplyButton}
            _handleSelectChange={this._handleSelectChange}
            tobaList={this.props.tobaList}
            _pushRoute={this.props.push}
            tobas={this.props.tobas}
        />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    tobaList: state.tobaList,
    tobas: state.tobas.tobas,
    fetchingTobas: state.tobas.fetching,
    solicitorGroups: state.groups.solicitorGroups,
    postingToba: state.toba.posting
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTobas: (parameters) => {
      dispatch(getTobas(parameters))
    },
    getSolicitorGroups: () => {
      dispatch(requestGetGroupsOfSolicitors())
    },
    push: (url) => {
      dispatch(push(url))
    },
    changeStoreSettings: (key, value) => {
      dispatch(changeTobaListStoreSettings(key, value))
    },
    deleteToba: (tobaId) => {
      dispatch(deleteToba(tobaId))
    },
    getTobaRevisions: (payload) => {
      dispatch(getTobaRevisions(payload))
    },
    clearNewToba: () => {
      dispatch(clearNewToba())
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(TobaListHOC);